import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Alert, Badge, Button, Col, Container, Form, Image, InputGroup, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { LoginInfo } from '../App';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import FollowButton from './FollowButton';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import Masonry from 'react-masonry-css';
import Tile from './common/Tile';
import TileAIGenerate from './common/TileAIGenerate';
import { isLoggin, updateTile } from '../service/LoginService';

const AIGeneraleImageList = () => {
    async function getUserInfo(userIdOrDisplayId){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/profile/"+userIdOrDisplayId)
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getUserSetting(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/userSetting/my")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getAIGeneraleImageList(userId,page){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/image/generated/"+userId+"/"+page).then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)

    // ナビゲート
    const navigate = useNavigate()

    const [userInfo, setUserInfo] = useState([]);
    const [userSetting, setUserSetting] = useState([]);
    const [messageList,setMessageList] = useState([])
    const [imageList,setImageList] = useState([])
    const [imagePage,setImagePage] = useState(1)
    const [previewSource,setPreviewSource] = useState("")
    const [previewFlg,setPreviewFlg] = useState(false)

    // パラメータ
    let param = useParams()
    let paramUserId = param.userId

    // 投稿遅延ロード
    const options = {
        root: null,
        rootMargin: "500px",
        threshold: 0.05
    }
    const observer = new IntersectionObserver((entries,observer)=>{
        entries.forEach(entry => {
            if(entry.intersectionRatio > 0){
                const imgEl = entry.target;
                //imgEl.src = imgEl.dataset.src;          
                observer.unobserve(entry.target);
                // ロードした部分まで進んだら追加読み込み
                if(imgEl.dataset.no !== undefined && parseInt(imgEl.dataset.no) === (imagePage * 200 - 1) ){
                    setImagePage(imagePage+1)
                }
              }
        })
    }, options);

    useEffect(() => {
        if(loginInfo.result === false){
            if(paramUserId === "slow"){
                dialog("","生成履歴を表示するにはログインしてください。")
            } else {
                navigate("/")
            }
        }
    },[loginInfo])

    useEffect(() => {
        if(loginInfo.result){
            // タイルモード
            setTileMode(loginInfo.tile === 1)
            if(paramUserId !== undefined && paramUserId !== "slow"){
                getUserInfo(paramUserId).then(r => setUserInfo(r))
            }
            getAIGeneraleImageList(paramUserId === undefined ? loginInfo.userId : paramUserId,imagePage).then(r => {
                if(r.result){
                    if(r.data.length > 0){
                        setImageList(imageList.concat(r.data))
                    } else {
                        if(imagePage === 1){
                            setImageList([])
                            dialog("","まだ投稿がありません。AI生成機能を利用してみませんか？")
                        }
                    }
                } else {
                    setImageList([])
                    dialog("確認",r.errors)
                }
            })
        }
    },[loginInfo,imagePage])

    useEffect(() => {
        // ユーザ設定
        getUserSetting().then(r => {
            if(r.result){
                setUserSetting(r)
            }
        })
        // タイトル設定
        document.querySelector("title").textContent = t("aiGenerateHistory.title") + " | アワートAI - AIイラスト無料生成&投稿SNS"

    },[])

    const [tileMode,setTileMode] = useState(true)
    const [isSrc,setIsSrc] = useState(false)

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }
    const breakpointColumnsObj = {
        default: 9,
        1800: 8,
        1600: 7,
        1400: 6,
        1200: 5,
        992: 4,
        768: 3,
        576: 2,
    }
    function path(data,isSrc){
        if(data.mode === "txt2img"){
            return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/'+data.mode+'/'+(data.proc_id)+ApiFetch.API_THUMB_EXT
        } else if(data.mode === "img2img" && !isSrc) {
            return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/'+data.mode+'/'+(data.proc_id)+ApiFetch.API_THUMB_EXT
        } else if(data.mode === "img2img" && isSrc) {
            return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/'+data.mode+'_src/'+(data.proc_id)+".png"
        }
    }
    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} />
        <Header />
        <Category />
        {previewFlg ? (
            <div style={{position:"fixed",top:0,left:0,width:"100%",height:"100%",zIndex:"2",cursor:"pointer"}} onClick={() => setPreviewFlg(false) }>
                <div style={{position:"fixed",top:0,left:0,backgroundColor:"#000000",width:"100%",height:"100%",opacity:0.9}} />
                <Image
                    src={previewSource}
                    id="preview"
                    style={{position:"fixed",objectFit:"contain",width:"100%",height:"100%"}}
                />
            </div>
            ) : ""}
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue"}}>
            <RIcon.FaHistory style={{color:"orange"}} /> {t("aiGenerateHistory.title")}
        </Container>
        <Container>
            {paramUserId !== undefined && paramUserId !== "slow" ? (
                <>
                <Image  style={{borderRadius:"50px"}} src={"//"+ApiFetch.IMG_HOST+"/profile/"+paramUserId+"_s.jpg?"+userInfo.hash}/><br />
                ユーザー名：<Link to={"/user/"+userInfo.user_id}>{userInfo.user_name}</Link><br />
                TwitterID：<a target="_blank" rel="noreferrer" href={"https://twitter.com/"+userInfo.twitter_id}>https://twitter.com/{userInfo.twitter_id}</a><br />
                </>
            ) : ""}
        </Container>
        <Container className='d-flex p-0'>
            <Row>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} checked={tileMode} onChange={(e) => {
                            updateTile(e.currentTarget.checked ? "on" : "off").then(r => {
                                if(r.result){
                                    isLoggin().then(json => {
                                        setLoginInfo(json)
                                    })
                                }
                            })
                            //setTileMode(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.tileMode")} readOnly />
                    </InputGroup>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} style={{}}>
                    <InputGroup style={{}}>
                        <InputGroup.Checkbox style={{cursor:"pointer"}} defaultChecked={isSrc} onClick={(e) => {
                            setIsSrc(e.currentTarget.checked)
                            }} />
                        <Form.Control type="text" value={t("common.img2img_src")} readOnly />
                    </InputGroup>
                </Col>
            </Row>
        </Container>
        {tileMode ? (
            <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
                >
                {imageList.map((data,i) => {
                    if(paramUserId !== undefined && paramUserId !== "all" && paramUserId !== "slow"){
                        data.user_id = ""
                        data.user_name = ""
                    }
                    return <TileAIGenerate isSrc={isSrc} data={data} i={i} dialog={dialog} key={i} observer={observer} />
                })}
            </Masonry>
        ) : (
        <Container className='d-flex flex-row justify-content-center flex-wrap w-100'>
            {imageList.map((data,i) => {
            return <Container style={{position:"relative",width:"180px",border:data.status === 8 || data.status === 9 ? "3px solid red" : "none"}} className="mb-3 p-0" key={i}>
                        <Container style={{position:"relative",width:"180px",height:"180px",padding:0}}>
                            <Badge bg="secondary" style={{position:"absolute",zIndex:"1",bottom:"20px",left:"20px"}}>
                                <a href={ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+data.mode+'/'+(data.proc_id)+".png"} download={"ourtai_"+data.proc_id+"_"+(i+1)+".png"}><Icon.CloudDownloadFill style={{fontSize:"24px",color:"#EEEEEE"}} /></a>
                            </Badge>
                            <Image
                            onClick={(e) => {
                                // ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+'/'+data.mode+'/'+(data.proc_id)+"_eco.webp"
                                setPreviewSource(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/1/0")
                                setPreviewFlg(true)
                            }}
                            data-no={i} loading="lazy" src={ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/sd/getImageSource/"+data.proc_id+"/1/0"}
                            style={{objectFit:"cover",position:"absolute",width:"100%",height:"100%",cursor:"pointer"}} className="p-1 lazy" />
                        </Container>
                        <Link to={"/user/"+data.user_id}>{data.user_name}</Link>
                        <Container style={{fontWeight:"bold",fontSize:"15px",whiteSpace:"nowrap",overflow:"hidden"}}>{data.create_datetime}</Container>
                    </Container>
            })}
        </Container>
        )}
        <Footer />
    </div>
    )
}

export default AIGeneraleImageList;
